import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import Logo from '../../fonts/logo.svg';
import HPBanner from '../../images/banner.svg';

export default function Home() {
  const navigate = useNavigate();

  const redirectLogin = () => {
    navigate('/login');
  };

  const redirectSignup = () => {
    navigate('/signup');
  };

  return (
      <div className="HomePage">
        <header className="home-nav">
          <div className="home-nav__logo">
            <img src={Logo} alt="ProjectLoop" />
          </div>
          <nav className="home-nav__links">
            <button type="button">Features</button>
            <button type="button">About Us</button>
            <button type="button">Pricing</button>
            <button type="button">Contact Us</button>
            <button type="button">ProjectLoop</button>
          </nav>
          <div className="home-nav__actions">
            <span className="nav-phone">833-444-9876</span>
            <Button onClick={redirectSignup} type="primary" className="sign-btn">
              Try it free
            </Button>
            <Button onClick={redirectLogin} className="login-btn">
              Login
            </Button>
          </div>
        </header>

        <section className="home-hero">
          <div className="home-hero__content">
            <div className="hero-pill">Get 90 Days On Us!</div>
            <h1>
              Field-First
              <br />
              Compliance Clarity.
            </h1>
            <p className="hero-subtitle">100% access. No credit card required.</p>
            <div className="hero-form">
              <input type="email" placeholder="Enter your work email" />
              <Button onClick={redirectSignup} type="primary">
                Sign up in 2 minutes
              </Button>
            </div>
            <div className="hero-actions">
              <Button onClick={redirectSignup} className="secondary-cta">
                Book a live demo
              </Button>
              <button type="button" className="text-link">
                Explore platform
              </button>
            </div>
            <div className="hero-badges">
              <div className="badge-card">Capterra 4.7</div>
              <div className="badge-card">GetApp 4.6</div>
              <div className="badge-card">Software Advice 4.6</div>
            </div>
          </div>
          <div className="home-hero__media">
            <div className="hero-screen">
              <img src={HPBanner} alt="ProjectLoop dashboard" />
            </div>
            <div className="hero-stats">
              <div className="stat-card">
                <p>Live Projects Monitored</p>
                <h3>10k+</h3>
              </div>
              <div className="stat-card">
                <p>Corrective Actions Handled</p>
                <h3>300k+</h3>
              </div>
              <div className="stat-card">
                <p>Training Compliance Achieved</p>
                <h3>96%</h3>
              </div>
            </div>
          </div>
        </section>

        <section className="home-trust">
          <p>Trusted by companies globally</p>
          <div className="trust-grid">
            <span>Northern Caulking</span>
            <span>Astro Excavating</span>
            <span>ASBEX Contractors</span>
            <span>BoT Builders</span>
            <span>Dayson Industrial</span>
            <span>Summit Forming</span>
            <span>Empire Works</span>
            <span>Selco Elevators</span>
          </div>
        </section>
      </div>
  );
}
